class BackToTop extends HTMLElement
{
  constructor() {
		super();
	}

	connectedCallback() {
		this.isAppear = false;
		this.threshold = 50;
		this.currentScrollTop = 0;
		this.onScrollHandler = this.onScroll.bind(this);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.onButtonClickHandler = this.onButtonClick.bind(this);


		this.addEventListener('click', this.onButtonClickHandler);
	}

	onScroll() {
		const scrollTop = document.documentElement.scrollTop;
		if (scrollTop > this.threshold && scrollTop < this.currentScrollTop) {
			if(!this.isAppear) {
				this.appear();	
			}
		} else {
			if(this.isAppear) {
				this.hide();
			}
		}
		this.currentScrollTop = scrollTop;
	}

	onButtonClick(event) {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	appear() {
		this.classList.remove('invisible');
		this.classList.remove('opacity-0');
		this.classList.remove('z-[2]');
		this.classList.add('z-[3]');
		this.isAppear = true;
	}

	hide() {
		this.classList.add('invisible');
		this.classList.add('opacity-0');
		this.classList.add('z-[2]');
		this.classList.remove('z-[3]');
		this.isAppear = false;
	}
}

customElements.define('back-to-top', BackToTop);